import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=07783025&scoped=true&"
import script from "./Pagos.vue?vue&type=script&lang=js&"
export * from "./Pagos.vue?vue&type=script&lang=js&"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=07783025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07783025",
  null
  
)

export default component.exports